export const environment = {
  production: false,
  env: 'Desarrollo',
  HomeTitle:'Clavis Utilitarios - Development environment',
  ApiUrl: "https://cltoolsapidev.clavisco.com/",
  recatpchaSiteKey: '6LcEL_EpAAAAAIvuGfcTDMcVd-DZhRdERKZ3HsB-',
  LogRocketId: ''
};
